import React, { useEffect, useState, useRef } from 'react';
import { Container, Image, Spinner } from 'react-bootstrap';
import BModal from 'react-bootstrap/Modal';
import { useNavigate } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import './job-title.css';

import logo from "../../../assets/images/MTDlogo.png";
import backarrow from "../../../assets/images/backarrow.jpg";
import responsivebg from "../../../assets/images/responsive-bg.png";

import Stepper from '../Stepper';
import { API_URL } from '../../../api';
import { useCookies } from '../../../hooks/useCookies';
import { questionsDefaultAnswers } from '../../../utils/constants';
import { useAlert } from "../../../Context/AlertModalContext";
import * as profileActions from "../../../actions/Profile";


export default function ProfileAnswers() {

  const [show, setShow] = useState(false);
  const [count, setCount] = useState(0);
  const [modalData, setModalData] = useState({
    heading: "",
    apiURL: "",
  });
  const { getCookie } = useCookies();
  const [questions, setQuestions] = useState([]);
  const navigate = useNavigate();
  const [alert, setAlert] = useState(false);
  const token = getCookie('token');
  const [refresh, setRefresh] = useState(false);
  const isFetched = useRef(false);
  const alertmodal = useAlert();



  useEffect(() => {
    if (isFetched.current) return;
    isFetched.current = true;
    if (!token) return;

    fetchQuestionsList();
  }, [token]);

  const fetchQuestionsList = async () => {
    const response = await profileActions.questionAnswersList()
    const data = await response;
    if (response) {
      setQuestions(data.questions);
    }
  }

  useEffect(() => {
    (async () => {
      const response = await profileActions.getQuestionsCount()
      const data = await response
      setCount(data.count);
    })()
  }, [refresh, token]);


  const refreshpage = () => {
    setRefresh(!refresh)
  }

  const handleAnswerSave = (questionId, newAnswer) => {
    setQuestions((prevQuestions) =>
      prevQuestions.map((q) =>
        q.question_id === questionId ? { ...q, answer: newAnswer } : q
      )
    );
  }

  const handleDeleteAnswer = async (questionId) => {
    try {
      alertmodal.setModal({
        show: true,
        message: "Are you sure you want to delete this answer.",
        title: "",
        onButtonClick: async () => {
          const response = await fetch(
            `${API_URL}customer/update/answer/${questionId}`,
            {
              method: "DELETE",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${getCookie("token")}`,
              },
            }
          );

          if (response.status === 200) {
            setQuestions(prevQuestions =>
              prevQuestions?.map(q =>
                q.question_id === questionId ? { ...q, answer: "" } : q
              )
            );
            setRefresh(prev => !prev);
          }
        },
      });
    } catch (error) {
      console.error("Error deleting answer:", error);
    }
  };


  return (
    <div className="job-container">
      <Modal
        className="customer-modal-without-header-footer"
        show={show}
        onHide={() => setShow(false)}
        modalData={modalData}
      />
      <AlertModal show={alert} count={count} onHide={() => setAlert(false)} />
      <div className="job-bg">
        <Image
          className="responsive-bg"
          src={responsivebg}
          alt="Background"
        ></Image>
      </div>
      <Container className="job-main">
        <Container className="job-content">
          <Container className="logo-progressbar10">
            <Container className="logo-arrow10">
              <Image
                src={backarrow}
                className="backarrow"
                onClick={() => window.history.back()}
                alt="Back Arrow"
              />
              <Image
                src={logo}
                alt="Logo"
                className="logo"
                style={{ backgroundColor: "transparent" }}
              />
            </Container>
            <Stepper activeStep="ProfileAnswers" />
          </Container>
          <div className="container-div">
            <Container className="job-details">
              <div className="container-child1">
                <div className="your-job">
                  <Container className="job-text">
                    <p>Write your profile answers</p>
                  </Container>
                  <p
                    style={{
                      color: "#4E1173",
                      fontSize: "16px",
                      lineHeight: "20px",
                      textAlign: "left",
                      fontWeight: "600",
                      marginLeft: "10px",
                    }}
                  >
                    2 prompts are required.
                  </p>
                  <div className="questions-types">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "1rem",
                      }}
                    >
                      {questions?.map((question, index) => (
                        <div
                          tabIndex={0}
                          key={index}
                          style={{
                            border: question.answer
                              ? "2px solid #4E1173"
                              : "2px solid #cbcbcb",
                            padding: "1rem",
                            borderRadius: "10px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setModalData({
                              heading: question.prompt,
                              apiURL: `${API_URL}customer/users/answer/${question.question_id}`,
                              refreshpage: refreshpage,
                              questionId: question.question_id,
                              onAnswerSaved: handleAnswerSave,
                              placeholder: questionsDefaultAnswers[index],
                            });
                            setShow(true);
                          }}
                        >
                          <div>
                            <div
                              style={{
                                color: "black",
                                fontSize: "18px",
                                lineHeight: "24px",
                                fontWeight: "600",
                              }}
                            >
                              {question.question}
                            </div>
                            <div
                              style={{
                                color: "#6C6C6C",
                                fontSize: "16px",
                                lineHeight: "20px",
                                fontWeight: "400",
                              }}
                            >
                              {question.answer ||
                                questionsDefaultAnswers[index]?.substring(
                                  0,
                                  30
                                ) + "..."}
                            </div>
                            <div
                              style={{
                                color: "#6C6C6C",
                                fontSize: "16px",
                                lineHeight: "20px",
                                fontWeight: "400",
                              }}
                            >
                              {question.description}
                            </div>
                          </div>
                          <div
                            style={{
                              marginTop: "3px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-end",
                              gap: "15px",
                            }}
                          >
                            {question?.answer && (
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  e.nativeEvent.stopImmediatePropagation();
                                  handleDeleteAnswer(question.question_id);
                                }}
                              >
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M15 1L1 15M1.00001 1L15 15"
                                    stroke="#424242"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </div>
                            )}

                            <svg
                              width="22"
                              height="22"
                              viewBox="0 0 22 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12.8346 5.5L7.33464 11V14.6667H11.0013L16.5013 9.16667M12.8346 5.5L15.5846 2.75L19.2513 6.41667L16.5013 9.16667M12.8346 5.5L16.5013 9.16667M9.16797 3.66667L3.66797 3.66667L3.66797 18.3333L18.3346 18.3333V12.8333"
                                stroke="url(#paint0_linear_778_6844)"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <defs>
                                <linearGradient
                                  id="paint0_linear_778_6844"
                                  x1="12.0869"
                                  y1="2.10069"
                                  x2="12.0869"
                                  y2="19.9566"
                                  gradientUnits="userSpaceOnUse"
                                >
                                  <stop stopColor="#FC8C66" />
                                  <stop offset="1" stopColor="#F76A7B" />
                                </linearGradient>
                              </defs>
                            </svg>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </Container>
          </div>
          <div className="d-flex justify-content-center next-btn">
            <button
              type="submit"
              className="global-next-bottom-fix-btn"
              onClick={() => {
                if (count === 2) {
                  navigate("/kids-family");
                } else {
                  setAlert(true);
                }
              }}
            >
              Next
            </button>
          </div>
        </Container>
      </Container>
    </div>
  );
};

function Modal({ show, onHide, modalData }) {
  const [text, setText] = useState("");
  const { getCookie, setCookie } = useCookies();
  const [textTouched, setTextTouched] = useState(false);
  const [isTextValid, setIsTextValid] = useState(text !== "")
  const token = getCookie('token');
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    setText("");

    (async () => {
      if (!modalData.apiURL) return;

      const response = await fetch(modalData.apiURL, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();
      if (response.ok) {
        setText(data.answer);
      }
    })()
  }, [modalData.apiURL, token]);

  async function saveAnswer() {
    const isEmpty = /^\s*$/.test(text);
    if (isEmpty) {
      setIsTextValid(false)
      setTextTouched(true)

      return
    } else {
      setIsTextValid(true)
    }

    const finalanswer = text ? text : ""
    setLoading(true)
    const response = await fetch(modalData.apiURL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ answer: finalanswer }),
    });
    await response.json();
    if (response.ok) {
      setLoading(false)
      if (modalData.questionId) {
        modalData.onAnswerSaved(modalData.questionId, finalanswer);
      }
      onHide();
      const answers = getCookie('answers');
      setCookie('answers', answers ? Number(answers) + 1 : 0, { path: '/' });
      modalData.refreshpage();
    }
    else {
      setLoading(false)
    }
  }

  return (
    <BModal className="customer-modal-without-header-footer"
      centered show={show} onHide={onHide} >
      <BModal.Header closeButton onClick={() => { onHide(); setText(""); setTextTouched(false) }}>
        <p style={{
          fontSize: "large",
          lineHeight: "24px",
          fontWeight: "600",
          padding: "10px"
        }}>{modalData.heading}</p>
      </BModal.Header>
      <div style={{
        width: "100%",
        position: "relative",
      }}>
        <textarea
          name={modalData.heading}
          id={modalData.heading}
          value={text}
          placeholder={modalData.placeholder}
          onChange={(e) => {
            setTextTouched(true);
            setText(e.target.value)

            if (e.target.value === "") {
              setIsTextValid(false)
            } else {
              setIsTextValid(true)
            }
          }}
          maxLength={200}
          style={{
            height: "300px",
            marginBlock: "1rem",
            borderRadius: "10px",
            border: `2px solid ${textTouched && !isTextValid ? 'red' : '#cbcbcb'}`,
            padding: "1rem",
            width: "100%",
          }}
        ></textarea>
        <p style={{
          position: "absolute",
          right: "1rem",
          bottom: "2rem",
          color: "#6C6C6C",
          fontSize: "14px",
          lineHeight: "20px",
          fontWeight: "400",
        }}>{text?.length}/200</p>
      </div>
      <div>
        {textTouched && !isTextValid && <p className="text-danger error-message">Please provide some input to save the data</p>}
        {text?.length >= 200 && (
          <p className="text-danger error-message">
            Max 200 characters allowed.
          </p>
        )}
      </div>
      <div style={{
        marginTop: "2rem",
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        gap: "1rem",
      }}>
        <button className='global-cancel-button' onClick={() => { onHide(); setText(""); setTextTouched(false) }}>
          Close
        </button>
        <button className='global-save-button' onClick={() => {
          saveAnswer()
        }}
          disabled={loading}>
          {loading ? (
            <Spinner animation="border" size="sm" role="status" />
          ) : (
            "Save"
          )}
        </button>
      </div>
    </BModal>
  )
}

function AlertModal({ show, onHide, count }) {
  return (
    <BModal className='customer-modal-without-header-footer' centered show={show} onHide={onHide}>
      <div>
        <p style={{
          fontSize: "var(--modal-font-size-16)",
          lineHeight: "var(--modal-line-height-24)",
          fontWeight: "500",
          textAlign: "center",
          marginTop: "1rem",
          color: "#515151"
        }}>
          {
            count !== 2 ? "Answer 2 prompts, please! Contact info (e.g., phone, social handles) will be rejected." : "Please answer 2 questions"
          }

        </p>
      </div>
      {/* 
            <Button style={{
                backgroundColor: "white",
                borderColor: "#6c6c6c",
                borderRadius: "9999px",
                padding: "0.5rem 1rem",
                color: "#6c6c6c",
                fontWeight: "600",
                margin: "1rem auto",
                width: "50%",
            }} onClick={() => { onHide(); }}>
                Okay
            </Button> */}


      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "60px",

      }}>
        <button type="submit" className='global-save-button' onClick={() => { onHide(); }}>
          Okay
        </button>
      </div>
    </BModal>
  )
}

